import { inject } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormConfig } from '../edit-create-form.interfaces';
import { SelectConfig } from '@shared/components/generic-select';
import { AppValidators } from '@shared/validators/app-validators';
import { LeadCampaignApiService } from '@shared/services';

// Gender options for lead
const GENDER_OPTIONS = [
  { label: 'Nam', value: 'male' },
  { label: 'Nữ', value: 'female' },
  { label: 'Khác', value: 'other' }
];

const GENDER_SELECT_CONFIG: SelectConfig = {
  staticOptions: GENDER_OPTIONS,
  optionLabel: 'label',
  optionValue: 'value',
  placeholder: 'Chọn giới tính'
};

export const leadFormConfig = (): FormConfig => {
  const leadCampaignApiService = inject(LeadCampaignApiService);

  const CAMPAIGN_SELECT_CONFIG: SelectConfig = {
    service: leadCampaignApiService,
    method: 'getOptions',
    idField: 'id',
    labelFormatter: (campaign: any) => `${campaign.code} - ${campaign.name}`,
    valueField: 'id',
    placeholder: 'Chọn campaign',
    sortField: 'code,asc',
    usePostMethod: true,
    bodyBuilder: (searchTerm: string, baseQuery: any, idQuery?: any) => {
      const body: any = {};
      const trimmedSearchTerm = searchTerm?.trim();

      if (idQuery && idQuery.id) {
        body.andQ = { id: idQuery.id };
      } else if (searchTerm && trimmedSearchTerm) {
        body.orQ = {
          code: trimmedSearchTerm,
          name: trimmedSearchTerm
        };
      }

      if (baseQuery && Object.keys(baseQuery).length > 0) {
        if (!body.andQ) {
          body.andQ = {};
        }
        body.andQ = { ...body.andQ, ...baseQuery };
      }

      return body;
    }
  };

  return {
    fields: [
      {
        key: 'id', label: 'ID', type: 'text', width: 'full', hidden: true
      },
      {
        key: 'lead_campaign_id', label: 'Campaign', required: true, width: 'half',
        type: 'select', config: CAMPAIGN_SELECT_CONFIG,
        placeholder: 'Chọn campaign',
        customErrorMessage: 'Campaign là bắt buộc'
      },
      {
        key: 'full_name', label: 'Họ tên', required: true, width: 'half',
        type: 'text', placeholder: 'Nhập họ tên',
        customErrorMessage: 'Họ tên là bắt buộc'
      },
      {
        key: 'phone', label: 'Số điện thoại', required: true, width: 'half',
        type: 'text', placeholder: 'Nhập số điện thoại',
        autoFormat: 'vnPhone',
        validators: [AppValidators.vnPhone],
        customErrorMessage: 'Số điện thoại không hợp lệ'
      },
      {
        key: 'email', label: 'Email', required: false, width: 'half',
        type: 'text', placeholder: 'Nhập email',
        validators: [Validators.email],
        customErrorMessage: 'Email không hợp lệ'
      },
      {
        key: 'birthday', label: 'Ngày sinh', width: 'half', type: 'datepicker', placeholder: 'Chọn ngày sinh'
      },
      {
        key: 'gender', label: 'Giới tính', required: false, width: 'half',
        type: 'select', config: GENDER_SELECT_CONFIG,
        placeholder: 'Chọn giới tính'
      },
      {
        key: 'address', label: 'Địa chỉ', required: false, width: 'full',
        type: 'textarea', placeholder: 'Nhập địa chỉ',
        rows: 2
      },
      {
        key: 'school', label: 'Trường học', required: false, width: 'half',
        type: 'text', placeholder: 'Nhập tên trường học'
      },
      {
        key: 'interested_course', label: 'Khoá học quan tâm', required: false, width: 'half',
        type: 'text', placeholder: 'Nhập khoá học quan tâm'
      },
      {
        key: 'aim', label: 'Mục tiêu', required: false, width: 'full',
        type: 'textarea', placeholder: 'Nhập mục tiêu',
        rows: 3
      }
    ]
  };
};

